import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { PBITableRow } from "../types";

type PBIDataTableProps = {
  data: PBITableRow[];
  textColor?: string;
};

export const PBIDataTable = ({ data, textColor }: PBIDataTableProps) => {
  if (!data || data.length === 0) {
    return null;
  }

  const columns = Object.keys(data[0]);

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{ mb: 1, fontWeight: "bold", color: textColor }}
      >
        📊 Data Table
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 400,
          bgcolor: "rgba(255, 255, 255, 0.95)",
          borderRadius: 1,
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column}
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "info.light",
                    color: "info.dark",
                    borderBottom: "2px solid",
                    borderBottomColor: "info.main",
                  }}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:nth-of-type(odd)": { bgcolor: "action.hover" } }}
              >
                {columns.map((column) => (
                  <TableCell key={column}>
                    {row[column] !== null && row[column] !== undefined
                      ? String(row[column])
                      : "—"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
